"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = require("../../runtime/dom");
var awsui_cards_filtering_1 = require("../table/awsui-cards-filtering");
var awsui_cards_property_filtering_1 = require("../table/awsui-cards-property-filtering");
var awsui_cards_preferences_1 = require("../table/awsui-cards-preferences");
var awsui_cards_pagination_1 = require("../table/awsui-cards-pagination");
var awsui_cards_page_size_selector_1 = require("../table/awsui-cards-page-size-selector");
var CardSectionWrapper = /** @class */ (function (_super) {
    __extends(CardSectionWrapper, _super);
    function CardSectionWrapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CardSectionWrapper.prototype.findHeader = function () {
        return this.find('.awsui-cards-card-section-header');
    };
    CardSectionWrapper.prototype.findContent = function () {
        return this.find('.awsui-cards-card-section-content');
    };
    return CardSectionWrapper;
}(dom_1.ElementWrapper));
exports.CardSectionWrapper = CardSectionWrapper;
var CardWrapper = /** @class */ (function (_super) {
    __extends(CardWrapper, _super);
    function CardWrapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CardWrapper.prototype.findSections = function () {
        return this.findAll('.awsui-cards-card-section').map(function (c) { return new CardSectionWrapper(c.getElement()); });
    };
    CardWrapper.prototype.findHeader = function () {
        return this.find('.awsui-cards-card-header-inner');
    };
    CardWrapper.prototype.findSelectionArea = function () {
        return this.find('.awsui-cards-card-selection-area');
    };
    return CardWrapper;
}(dom_1.ElementWrapper));
exports.CardWrapper = CardWrapper;
var mapCards = function (cards) { return cards.map(function (c) { return new CardWrapper(c.getElement()); }); };
var CardsWrapper = /** @class */ (function (_super) {
    __extends(CardsWrapper, _super);
    function CardsWrapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CardsWrapper.prototype.findItems = function () {
        return mapCards(this.findAll('.awsui-cards-card-container'));
    };
    CardsWrapper.prototype.findSelectedItems = function () {
        return mapCards(this.findAll('.awsui-cards-card-container.awsui-cards-card-selected'));
    };
    CardsWrapper.prototype.findHeaderRegion = function () {
        return this.find('[awsui-cards-region="header"]');
    };
    CardsWrapper.prototype.findNoMatchRegion = function () {
        return this.find('[awsui-cards-region="noMatch"]');
    };
    CardsWrapper.prototype.findEmptyRegion = function () {
        return this.find('[awsui-cards-region="empty"]');
    };
    CardsWrapper.prototype.findLoadingSpinner = function () {
        return this.find('.awsui-cards-container.awsui-cards-loading awsui-spinner');
    };
    CardsWrapper.prototype.findLoadingText = function () {
        return this.find('.awsui-util-status-inactive');
    };
    CardsWrapper.prototype.findFiltering = function () {
        return new awsui_cards_filtering_1.default(this.find('awsui-cards-filtering').getElement());
    };
    CardsWrapper.prototype.findPropertyFiltering = function () {
        return new awsui_cards_property_filtering_1.default(this.find('awsui-cards-property-filtering').getElement());
    };
    CardsWrapper.prototype.findPreferences = function () {
        return new awsui_cards_preferences_1.default(this.find('awsui-cards-preferences').getElement());
    };
    CardsWrapper.prototype.findPagination = function () {
        return new awsui_cards_pagination_1.default(this.find('awsui-cards-pagination').getElement());
    };
    CardsWrapper.prototype.findPageSizeSelector = function () {
        return new awsui_cards_page_size_selector_1.default(this.find('awsui-cards-page-size-selector').getElement());
    };
    return CardsWrapper;
}(dom_1.ComponentWrapper));
exports.default = CardsWrapper;
//# sourceMappingURL=awsui-cards.js.map